import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Trash2, Loader2, FileCheck2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { api } from "../../lib/api";

export const RequiredDocsDialog = ({ open, onOpenChange, onSaved }) => {
  const [items, setItems] = useState([]);
  const [types, setTypes] = useState([]);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (!open) return;
    api.requiredDocs().then((r) => setItems(r.items || [])).catch(() => {});
    api.contractTypes().then((r) => setTypes(r.types || r.items || (Array.isArray(r) ? r : []))).catch(() => {});
  }, [open]);
  const upd = (i, p) => setItems((x) => x.map((d, j) => (j === i ? { ...d, ...p } : d)));
  const toggleType = (i, t) => upd(i, { contract_types: items[i].contract_types.includes(t) ? items[i].contract_types.filter((x) => x !== t) : [...items[i].contract_types, t] });
  const save = async () => {
    setBusy(true);
    try { await api.saveRequiredDocs(items.filter((d) => d.label.trim())); toast.success("تم حفظ الوثائق الأساسية"); onSaved?.(); onOpenChange(false); }
    catch (e) { toast.error(e?.response?.data?.detail || "تعذّر الحفظ"); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent dir="rtl" className="max-h-[90vh] overflow-y-auto sm:max-w-2xl" data-testid="required-docs-dialog">
        <DialogHeader className="text-start">
          <DialogTitle className="flex items-center gap-2"><FileCheck2 className="h-5 w-5 text-blue-600" /> الوثائق الأساسية الإلزامية</DialogTitle>
          <DialogDescription>حدد الوثائق المطلوبة من كل موظف حسب نوع العقد — تظهر تلقائياً في ملف كل موظف، وتنبيه في الشاشة الرئيسية بمن ينقصه.</DialogDescription>
        </DialogHeader>
        <div className="space-y-2.5">
          {items.map((d, i) => (
            <div key={d.id || i} className="rounded-xl border border-slate-200 p-3" data-testid={`req-doc-${i}`}>
              <div className="flex gap-2">
                <Input value={d.label} onChange={(e) => upd(i, { label: e.target.value })} placeholder="اسم الوثيقة (مثال: سند لأمر)" data-testid={`req-doc-label-${i}`} />
                <button onClick={() => setItems((x) => x.filter((_, j) => j !== i))} className="rounded-md p-2 text-rose-500 hover:bg-rose-50" data-testid={`req-doc-del-${i}`}><Trash2 className="h-4 w-4" /></button>
              </div>
              <p className="mb-1 mt-2 text-[11px] text-slate-500">إلزامية لـ {d.contract_types.length ? "" : <b>كل الموظفين</b>}</p>
              <div className="flex flex-wrap gap-1.5">
                {types.map((t) => (
                  <button key={t} type="button" onClick={() => toggleType(i, t)} data-testid={`req-doc-${i}-type-${t}`}
                    className={`rounded-full border px-2.5 py-0.5 text-xs font-semibold ${d.contract_types.includes(t) ? "border-blue-600 bg-blue-600 text-white" : "border-slate-200 text-slate-600 hover:border-blue-300"}`}>{t}</button>))}
                {!types.length && <span className="text-[11px] text-slate-400">أضف أنواع العقود (مندوب، إداري، سعودة…) من نموذج الموظف ← نوع العقد</span>}
              </div>
            </div>
          ))}
          <Button variant="outline" className="w-full gap-1.5" onClick={() => setItems((x) => [...x, { label: "", contract_types: [], has_expiry: false }])} data-testid="req-doc-add"><Plus className="h-4 w-4" /> إضافة وثيقة أساسية</Button>
          <Button className="w-full" disabled={busy} onClick={save} data-testid="req-doc-save">{busy && <Loader2 className="h-4 w-4 animate-spin" />} حفظ</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
